import { useSelector } from 'react-redux';
import {
  hasPermission,
  hasFeature,
  canViewActivity,
  getEffectivePermissions,
  getUserRole,
  isAdmin,
  isManager,
} from '../utils/roleAccess';

export const usePermissions = () => {
  const user = useSelector((state) => state.common.userDetails);
  const userRole = getUserRole(user);

  return {
    // Check if user can access a specific route
    canAccess: (route) => hasPermission(user, route),

    // Check a feature key (see PERMISSIONS in roleAccess.js)
    hasFeature: (key) => hasFeature(user, key),

    // Effective permission list for this account
    permissions: getEffectivePermissions(user),

    // May this account see submission / post / entry counts?
    canViewActivity: canViewActivity(user),

    // Account was issued a temporary password and must change it first
    mustChangePassword: !!user?.mustChangePassword,

    // Check if user has admin role
    isAdmin: isAdmin(userRole),

    // Check if user has manager role
    isManager: isManager(userRole),

    // Get current user role
    userRole,

    // Get user details
    user,

    // Check if user is authenticated
    isAuthenticated: !!user,
  };
};
